import React from 'react';
import {connect} from 'react-redux';
import classNames from 'classnames';

import Avatar from 'components/Avatar';

import {Options, Message, EditNoteForm} from './components';

import './styles.css';

const SHOW_MORE_TEXT_CUTTOFF = 180;

class NoteBlock extends React.Component<any> {
  state = {
    showMore: false
  };

  archiveNote = () => {
    this.props.archiveNote({noteId: this.props.note.id});
  };

  restoreNote = () => this.props.restoreNote({noteId: this.props.note.id});

  toggleShowMore = () => this.setState({showMore: true});

  seeShowMoreButton = () =>
    !this.state.showMore &&
    this.props.note.text.length > SHOW_MORE_TEXT_CUTTOFF;

  submitEditNoteForm = ({noteText}) =>
    this.props.submitEditNoteForm({text: noteText, noteId: this.props.note.id});

  setNoteForEdit = () =>
    this.props.setNoteForEdit({noteId: this.props.note.id});

  unsetNoteForEdit = () => this.props.setNoteForEdit({noteId: null});

  render() {
    const {
      note: {
        createdBy: {internalAvatarCropped, avatarCropped, initials, fullName},
        createdAt,
        text,
        archived,
        id,
        canBeEdited
      },
      editNoteId,
      addOptions,
      editNote,
      optionsDropdownClassName
    } = this.props;

    const messageText = this.seeShowMoreButton()
      ? text.slice(0, SHOW_MORE_TEXT_CUTTOFF) + '...'
      : text;

    const inEditMode = editNoteId === id;
    return (
      <div className={classNames('NoteBlock', {inEditMode})}>
        <div className="avatar">
          <Avatar
            width={64}
            url={internalAvatarCropped || avatarCropped}
            initials={initials}
          />
        </div>
        {!inEditMode && (
          <React.Fragment>
            <Message
              text={messageText}
              showMoreButton={this.seeShowMoreButton()}
              name={fullName}
              createdAt={createdAt}
              toggleShowMore={this.toggleShowMore}
            />
            {addOptions && (
              <Options
                archived={archived}
                canBeEdited={canBeEdited}
                archiveNote={this.archiveNote}
                restoreNote={this.restoreNote}
                editNote={this.setNoteForEdit}
                dropdownClassName={optionsDropdownClassName}
              />
            )}
          </React.Fragment>
        )}
        {inEditMode &&
          editNote && (
            <EditNoteForm
              message={text}
              noteId={id}
              hideEditNoteForm={this.unsetNoteForEdit}
              submitAction={this.submitEditNoteForm}
              formName={this.props.editFormName}
            />
          )}
      </div>
    );
  }
}

const mapStateToProps = (state, props) => {
  const editNoteId = props.editNote && props.editNoteSelector(state);

  return {
    editNoteId
  };
};

export default connect(mapStateToProps)(NoteBlock);
